import React from 'react';
import Card from '../common/Card';

export default function FolderCard({ folder, onClick }) {
  return (
    <Card hover className="mol-folder-card" onClick={onClick}>
      <div className="mol-folder-card__icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#00B4FE" strokeWidth="1.5">
          <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
        </svg>
      </div>
      <span className="mol-folder-card__name">{folder.name}</span>
    </Card>
  );
}
